import React from 'react';
import { useLocation } from 'react-router-dom';
import PropertyDetails from '../../Tenant/components/PropertyDetails';
import PublicSiteHeader from '../../../components/PublicSiteHeader/PublicSiteHeader';
import '../../../components/PublicSiteHeader/publicSiteLayout.css';

/**
 * PublicPropertyDetails is a "Teaser" version of the property details page.
 * It strictly enforces teaserMode to ensure that all interactive actions
 * (Booking, Map, Call, etc.) prompt the user to join the dashboard flow.
 * Includes the same site header / logo as /listings for consistent public chrome.
 */
const PublicPropertyDetails = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const forceGuestView = location?.state?.asGuest === true || query.get('guest') === '1';

  return (
    <>
      <PublicSiteHeader forceGuestView={forceGuestView} />
      <div className="public-page-below-site-header">
        <PropertyDetails teaserMode />
      </div>
    </>
  );
};

export default PublicPropertyDetails;
